import axios from 'axios'
import Constantes from '../../utils/constantes'

const state = {
  carrinho: [],
  pedidos: [],
  pedido: null,
  valorFrete: "",
  totalComFrete: "",
  totalSemFrete: "",
  tipoEntrega: "",
  qtdParcelas: 1,
}

// getters
const getters = {
  carrinho (state) {
    return state.carrinho
  },
  qtdParcelas (state) {
    return state.qtdParcelas
  },
  pedidos (state) {
    return state.pedidos
  },
  pedido (state) {
    return state.pedido
  },
  itens (state) {
    return state.pedido.itens
  },
  contadorCarrinho (state) {
    return state.carrinho.length
  },
  valorFrete (state) {
    return state.valorFrete
  },
  totalPedidoComFrete (state) {
    return state.totalComFrete
  },
  totalPedidoSemFrete (state) {
    return state.totalSemFrete
  },
  tipoEntrega (state) {
    return state.tipoEntrega
  }
}

// actions
const actions = {
  totalPedidoSemFrete ({ commit, state }, payload) {
    if (state.carrinho.length > 0) {
      state.totalSemFrete = state.carrinho
        .map((item) => item.anuncio.ancFltPrecoVendaDesconto * item.carIntQtd)
        .reduce((a, v) => a + v);
    } else {
      state.totalSemFrete = 0;
    }
    // console.log("state.total  SEM  Frete", Math.round((state.totalSemFrete + Number.EPSILON) * 100) / 100)
    return Math.round((state.totalSemFrete + Number.EPSILON) * 100) / 100
  },
  totalPedidoComFrete ({ commit, state }, payload) {
    if (state.carrinho.length > 0) {
      state.totalComFrete = state.carrinho
        .map((item) => item.anuncio.ancFltPrecoVendaDesconto * item.carIntQtd)
        .reduce((a, v) => a + v);
    } else {
      state.totalComFrete = 0;
    }
    // console.log("state.valorFrete", state.valorFrete)
    if (state.valorFrete !== true && state.valorFrete !== "Não há uma tabela de valores de frete para sua região! Favor entrar em contato com a concessionária via chat.") {
      state.totalComFrete += state.valorFrete
    } 
    // console.log("state.total  COM   Frete", state.totalComFrete)
    return Math.round((state.totalComFrete + Number.EPSILON) * 100) / 100
  },
  alterarCarrinho ({ commit }, payload) {
    commit('core/setLoading', true, { root: true })
    commit('core/clearError', null, { root: true })
    // console.log('alterarCarrinho', payload)
    axios({
      method: 'POST',
      url: Constantes.URL_SERVIDOR + '/carrinho/alterar',
      data: payload
    }).then(
      result => {
        commit('core/setLoading', false, { root: true })
      },
      error => {
        console.error(error)
        commit('core/setLoading', false, { root: true })
        commit('core/setError', error, { root: true })
      }
    )
  },
  removerCarrinho ({ commit, getters, dispatch }, payload) {
    commit('core/setLoading', true, { root: true })
    commit('core/clearError', null, { root: true })
    // console.log('removerCarrinho', payload)
    const car = getters.carrinho[payload];
    axios({
      method: 'POST',
      url: Constantes.URL_SERVIDOR + '/carrinho/remove',
      data: car
    }).then(
      result => {
        commit('removerCarrinho', payload)
        commit('core/setLoading', false, { root: true })
        dispatch('totalPedidoComFrete')
        dispatch('totalPedidoSemFrete')
      },
      error => {
        console.error(error)
        commit('core/setLoading', false, { root: true })
        commit('core/setError', error, { root: true })
      }
    )
  },
  adicionarCarrinho ({ commit, dispatch }, payload) {
    commit('core/setLoading', true, { root: true })
    commit('core/clearError', null, { root: true })
    // console.log('adicionarCarrinho', payload)
    axios({
      method: 'POST',
      url: Constantes.URL_SERVIDOR + '/carrinho/save',
      data: payload
    }).then(
      result => {
        if (result.data !== '') {
          // console.log('adicionarCarrinho => result.data', result.data)
          commit('adicionarCarrinho', result.data)
          dispatch('totalPedidoComFrete')
          dispatch('totalPedidoSemFrete')
        } else {
          commit('core/setError', { message: 'Erro ao adicionar no carrinho.' }, { root: true })
        }
        commit('core/setLoading', false, { root: true })
      },
      error => {
        console.error(error)
        commit('core/setLoading', false, { root: true })
        commit('core/setError', error, { root: true })
      }
    )
  },
  removeItensCarrinhoOutraLoja ({ commit, getters }, payload) {
    // console.log('removeItensCarrinhoOutraLoja', getters.carrinho)
    commit('setCarrinho', [])
    // console.log('carrinho', getters.carrinho)
  },
  carregarPedidos ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setPedidos', [])
      // console.log(`${Constantes.URL_SERVIDOR}/pedido/pedidos?cliIntCod=${payload.cliIntCod}`)
      commit('core/clearError', null, { root: true })
      commit('core/setLoading', true, { root: true })
      axios({
        method: 'GET',
        url: `${Constantes.URL_SERVIDOR}/pedido/pedidos?cliIntCod=${payload.cliIntCod}`
      }).then(
        result => {
          if (result.data !== '') {
            // console.log('carregarPedidos => result.data', result.data)
            commit('setPedidos', result.data)
          } else {
            commit('core/setError', { message: 'Erro ao carregar Pedidos.' }, { root: true })
          }
          commit('core/setLoading', false, { root: true })
          resolve()
        },
        error => {
          console.error(error)
          commit('core/setError', error, { root: true })
          commit('core/setLoading', false, { root: true })
          reject()
        }
      )
    });
  },
  carregarPedido ({ commit }, payload) {
    // console.log('carregarPedido', payload)
    // console.log(`${Constantes.URL_SERVIDOR}/pedido/find?pedIntCod=${payload.bpdIntCod}`)
    commit('core/clearError', null, { root: true })
    commit('core/setLoading', true, { root: true })
    axios({
      method: 'GET',
      url: `${Constantes.URL_SERVIDOR}/pedido/find?pedIntCod=${payload.bpdIntCod}`
    }).then(
      result => {
        if (result.data !== '') {
          // console.log('carregarPedidos => result.data', result.data)
          commit('setPedido', result.data)
        } else {
          commit('core/setError', { message: 'Erro ao carregar Pedido.' }, { root: true })
        }
        commit('core/setLoading', false, { root: true })
      },
      error => {
        console.error(error)
        commit('core/setError', error, { root: true })
        commit('core/setLoading', false, { root: true })
      }
    )
  },
  carregarCarrinho ({ commit, getters, dispatch, rootGetters }, payload) {
    // console.log('carregarCarrinho', payload)
    commit('core/clearError', null, { root: true })
    commit('core/setLoading', true, { root: true })
    axios({
      method: 'GET',
      url: `${Constantes.URL_SERVIDOR}/carrinho/cliente?cliIntCod=${payload}`
    }).then(
      result => {
        if (result.data !== '') {
          // console.log('carregarCarrinho => result.data', result.data)
          // console.log('carrinho vazio ', getters.carrinho)
          //console.log(rootGetters['cliente/user'])
          if (result.data.length > 0) {
            commit('setCarrinho', result.data)
            dispatch('totalPedidoComFrete')
            dispatch('totalPedidoSemFrete')
          }
          // else {
          //   //console.log('carrinho vazio ', getters.carrinho)
          //   //console.log('carrinho vazio ', getters.carrinho.length)
          //   if (getters.carrinho && getters.carrinho.length > 0) {
          //     getters.carrinho.forEach(e => {
          //       e.cliente = rootGetters['cliente/user'];
          //       console.log('enviando ', e)
          //       dispatch('adicionarCarrinho', e);
          //       commit('removerCarrinho', e);
          //     });
          //   }
          // }
        } else {
          commit('core/setError', { message: 'Erro ao carregar Carrinho.' }, { root: true })
        }
        commit('core/setLoading', false, { root: true })
      },
      error => {
        console.error(error)
        commit('core/setError', error, { root: true })
        commit('core/setLoading', false, { root: true })
      }
    )
  },
  salvarItem ({ commit }, payload) {
    commit('core/setLoading', true, { root: true })
    commit('core/clearError', null, { root: true })
    axios({
      method: 'POST',
      url: Constantes.URL_SERVIDOR + '/pedido/save/item',
      data: {
        bpiIntCod: payload.bpiIntCod,
        bpiStrStatus: payload.bpiStrStatus,
      }
    }).then(
      commit('core/setLoading', false, { root: true }),
      error => {
        console.error(error)
        commit('core/setLoading', false, { root: true })
        commit('core/setError', error, { root: true })
      }
    )
  },
  confirmarRecebimento ({ commit }, payload) {
    commit('core/setLoading', true, { root: true })
    commit('core/clearError', null, { root: true })
    axios({
      method: 'POST',
      url: Constantes.URL_SERVIDOR + '/pedido/recebimento',
      data: {
        bpdIntCod: payload.bpdIntCod,
      }
    }).then(
      result => {
        if (result.data !== '') {
          // console.log('confirmarRecebimento => result.data', result.data)
          commit('setPedido', result.data)
        } else {
          commit('core/setError', { message: 'Erro ao finalizar pedido.' }, { root: true })
        }
        commit('core/setLoading', false, { root: true })
      }, error => {
        console.error(error)
        commit('core/setLoading', false, { root: true })
        commit('core/setError', error, { root: true })
      }
    )
  },
  salvarAvaliacao ({ commit }, payload) {
    commit('core/setLoading', true, { root: true })
    commit('core/clearError', null, { root: true })
    axios({
      method: 'POST',
      url: Constantes.URL_SERVIDOR + '/pedido/save/avaliacao',
      data: {
        bpdIntCod: payload.bpdIntCod,
        bpdIntAvaliacao: payload.bpdIntAvaliacao,
      }
    }).then(
      commit('core/setLoading', false, { root: true }),
      error => {
        console.error(error)
        commit('core/setLoading', false, { root: true })
        commit('core/setError', error, { root: true })
      }
    )
  },
  setPedido ({ commit, dispatch }, payload) {
    commit('setPedido', payload)
    dispatch('carregarPedido', payload)
  },


  finalizarPedido ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('core/setLoading', true, { root: true })
      commit('core/clearError', null, { root: true })
      axios({
        method: 'POST',
        url: Constantes.URL_SERVIDOR + '/pedido/save',
        data: {
          busuario: payload.busuario,
          cliente: payload.cliente,
          carrinho: payload.carrinho,
          cartaoCredito: payload.dadosCartao,
          tipoPagamento: payload.tipoPagamento,
          frete: payload.frete,
          tipoEntrega: payload.tipoEntrega
        }
      }).then(
        result => {
          if (result.data !== '') {
            // console.log('finalizarPedido => result.data', result.data)
            commit('setPedido', result.data)
            commit('setCarrinho', [])
            resolve()
          } else {
            commit('core/setError', { message: 'Erro ao finalizar pedido.' }, { root: true })
            reject()
          }
          commit('core/setLoading', false, { root: true })
        },
        error => {
          console.error(error)
          commit('core/setLoading', false, { root: true })
          commit('core/setError', error, { root: true })
          reject()
        }
      )
    });
  },

  solicitarEstorno ({ commit }, payload) {
    commit('core/setLoading', true, { root: true })
    commit('core/clearError', null, { root: true })
    axios({
      method: 'POST',
      url: Constantes.URL_SERVIDOR + '/pedido/cancelamentoitem',
      data: {
        bpiIntCod: payload,
      }
    }).then(
      result => {
        if (result.data !== '') {
          // console.log('finalizarPedido => result.data', result.data)
          commit('setPedido', result.data)
          // commit('setCarrinho', [])
        } else {
          commit('core/setError', { message: 'Erro ao solocitar estorno.' }, { root: true })
        }
        commit('core/setLoading', false, { root: true })
      },
      error => {
        console.error(error)
        commit('core/setLoading', false, { root: true })
        commit('core/setError', error, { root: true })
      }
    )
  },

  calcularFrete ({ commit, dispatch }, payload) {
    // console.log("CEP", payload)
    commit('core/setLoading', true, { root: true })
    commit('core/clearError', null, { root: true })
    axios({
      method: 'GET',
      url: `${Constantes.URL_SERVIDOR_IS}/b2cpedido/calcularFrete/${payload.cep}/${payload.cliIntCod}/${payload.empIntCod}/${payload.valor}`
    }).then(
      result => {
        if (result.data !== '') {
          commit('setValorFrete', result.data)
          dispatch('totalPedidoComFrete')
          dispatch('totalPedidoSemFrete')
        } else {
          commit('core/setError', { message: 'Erro ao calcular frete.' }, { root: true })
        }
        commit('core/setLoading', false, { root: true })
      },
      error => {
        console.error(error)
        commit('core/setLoading', false, { root: true })
        commit('core/setError', { message: 'Erro ao calcular frete.' }, { root: true })
      }
    )
  },

  carregarQtdParcelas ({ commit, dispatch }, payload) {
    commit('core/setLoading', true, { root: true })
    commit('core/clearError', null, { root: true })
    axios({
      method: 'GET',
      url: `${Constantes.URL_SERVIDOR}/pedido/qtdparcelas?empIntCod=${payload.empIntCod}&totalPedido=${payload.totalPedido}`
    }).then(
      result => {
        if (result.data !== '') {
          //console.log('setQtdParcelas', result.data)
          commit('setQtdParcelas', result.data)
        } else {
          commit('core/setError', { message: 'Erro ao calcular quantidade de parcelas.' }, { root: true })
        }
        commit('core/setLoading', false, { root: true })
      },
      error => {
        console.error(error)
        commit('core/setLoading', false, { root: true })
        commit('core/setError', { message: 'Erro ao quantidade frete.' }, { root: true })
      }
    )
  },

  tipoEntrega ({ commit }, payload) {
    commit('setTipoEntrega', payload)
  },

}

// mutations
const mutations = {
  setCarrinho (state, payload) {
    // console.log('setCarrinho', payload)
    state.carrinho = payload
  },
  adicionarCarrinho (state, payload) {
    state.carrinho.push(payload)
  },
  removerCarrinho (state, payload) {
    state.carrinho.splice(payload, 1);
  },
  setPedidos (state, payload) {
    state.pedidos = payload
    state.pedidos.map((e) => {
      if (e.bpiStrStatus === 'ORÇAMENTO PENDENTE') {
        e.bpiFltPrecoVenda = 0;
        e.bpiFltPrecoTotal = 0;
        e.bpiFltPrecoVendaStr = '-';
        e.bpiFltPrecoTotalStr = '-';
      }
      return e;
    });
  },
  setPedido (state, payload) {
    // console.log("PEDIDO", payload)
    state.pedido = payload
  },
  setValorFrete (state, payload) {
    state.valorFrete = payload
  },
  setTipoEntrega (state, payload) {
    state.tipoEntrega = payload
  },
  setQtdParcelas (state, payload) {
    state.qtdParcelas = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
